export default __webpack_public_path__ + "assets/theia-2.0f7376c7.png";